<template src="./template.html"></template>

<script>
  import MetaHeader from '@/components/layout/MetaHeader'

  export default {
    name: 'CancelationOverlay',
    components: {
      MetaHeader,
    },
    props: {
      cancelationType: String,
    },
    data() {
      return {
        isOpen: true,
      }
    },
    computed: {
      opened: {
        set() {
          this.isOpen = false
        },
        get() {
          return this.isOpen
        },
      },
      profileCancelationMessage() {
        return this.$t('profile.own_profile')[this.cancelationType] && this.$t('profile.own_profile')[this.cancelationType].message
      },
      profileCancelationTitle() {
        return this.$t('profile.own_profile')[this.cancelationType] && this.$t('profile.own_profile')[this.cancelationType].overlay_title
      },
    },
    methods: {
      closeCancelationOverlay() {
        this.opened = false
        this.$emit('closeCancelationOverlay')
      },
      confirmCancelation() {
        this.$emit('confirmCancelation', this.cancelationType)
      },
    },
  }
</script>
